/**
 * Prefetch target plan details for assign/copy flows.
 */
import { fetchTargetPlanDetails } from '../api/dietApi';

const unwrapPlanPayload = (res) => res?.data?.data ?? res?.data ?? res;

const prefetchCache = new Map();

export function prefetchTargetPlanDetails(eventTypeId, planId, clientId) {
  if (!eventTypeId || !planId || !clientId) {
    return Promise.resolve(null);
  }
  const key = `${eventTypeId}:${clientId}:${planId}`;
  if (prefetchCache.has(key)) {
    return prefetchCache.get(key);
  }
  const promise = fetchTargetPlanDetails(eventTypeId, planId, clientId).then(
    (res) => {
      if (!res.success) {
        prefetchCache.delete(key);
        return null;
      }
      return unwrapPlanPayload(res);
    }
  );
  prefetchCache.set(key, promise);
  return promise;
}

/** Drop hover-prefetch after plan mutations. */
export function invalidateTargetPlanPrefetch() {
  prefetchCache.clear();
}
